import { render, staticRenderFns } from "./CardProject.component.vue?vue&type=template&id=38a4d6e1"
import script from "./CardProject.component.vue?vue&type=script&lang=js"
export * from "./CardProject.component.vue?vue&type=script&lang=js"
import style0 from "./CardProject.component.vue?vue&type=style&index=0&id=38a4d6e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports